import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Location } from '@angular/common';
import { UtilDadosLogado } from './util.logado';
import { map } from 'rxjs/operators';
@Injectable()
export class UtilServico {
    constructor(private http: Http, location: Location, private UtilDadosLogado: UtilDadosLogado) { }

    Get(metodo: string, options: any = null) {
        if (!options)
            options = this.headers();

        return this.http.get(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/" + metodo, options)
            .pipe(map((res: Response) => res.json()));
    }

    Put(metodo: string, dados: any) {
        let body = JSON.stringify(dados);
        return this.http.put(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/" + metodo, body, this.headers())
            .pipe(map((res: Response) => res.json()));
    }

    Post(metodo: string, dados: any, options: any = null) {
        if (!options)
            options = this.headers();

        let body = dados;
        return this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/" + metodo, body, options).pipe(
            map((res: Response) => res.json()));
    }

    private headers() {
        let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
        return new RequestOptions({ headers: headers });
    }
}
